import { Component } from '@angular/core';
import { shareButtonData } from './share-button.json';
import { environment } from '@environments/environment';
@Component({
  selector: 'app-share-button',
  standalone: true,
  imports: [],
  templateUrl: './share-button.component.html',
  styleUrl: './share-button.component.scss'
})
export class ShareButtonComponent {
  iconList = shareButtonData;

  get shareUrl() {
    return `${environment.drupalApi}/${window.location.pathname}`;
  }
}
